import { Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Tooltip } from '@mui/material';
import { action, makeObservable, observable } from 'mobx';
import { observer } from 'mobx-react';
import React from 'react';
import IconePje from '../img/icones/IconePJe';
import Ambiente from '../utils/Ambiente';

interface IPropsBotaoAbrirProcessoPJe {
    idProcesso: number;
    larguraIcone?: string;
    alturaIcone?: string;
    tamanhoBotao?: 'small' | 'medium' | 'large';
}


class BotaoAbrirProcessoPJe extends React.Component<IPropsBotaoAbrirProcessoPJe> {

    private readonly chaveOrientacaoPJeExibida = 'ge-pje-orientacao-login-exibida';
    private readonly tempoCliqueRepetidoProcesso = 5 * 60 * 1000;

    modalOrientacaoLoginPJeAberta = false;

    constructor(props: IPropsBotaoAbrirProcessoPJe) {
        super(props);
        makeObservable(this, {
            modalOrientacaoLoginPJeAberta: observable,
            abrirModalOrientacaoLoginPJe: action,
            fecharModalOrientacaoLoginPJe: action
        });
    }

    montarUrlDetalheProcessoPJe = () => {
        return Ambiente.urlPJe + this.props.idProcesso + '/detalhe';
    }

    montarUrlLoginPJeTst = () => {
        return Ambiente.urlPJe.split('/pjekz/')[0] + '/tst/login.seam';
    }

    chaveUltimoCliqueProcesso = () => {
        return 'ge-pje-ultimo-clique-processo-' + this.props.idProcesso;
    }

    orientacaoLoginPJeJaExibida = () => {
        return sessionStorage.getItem(this.chaveOrientacaoPJeExibida) === 'true';
    }

    clicouNoMesmoProcessoRecentemente = () => {
        const ultimoClique = Number(sessionStorage.getItem(this.chaveUltimoCliqueProcesso()));
        return ultimoClique && Date.now() - ultimoClique < this.tempoCliqueRepetidoProcesso;
    }

    registrarCliqueProcesso = () => {
        sessionStorage.setItem(this.chaveUltimoCliqueProcesso(), Date.now().toString());
    }

    abrirModalOrientacaoLoginPJe = () => {
        sessionStorage.setItem(this.chaveOrientacaoPJeExibida, 'true');
        this.modalOrientacaoLoginPJeAberta = true;
    }

    fecharModalOrientacaoLoginPJe = () => {
        this.modalOrientacaoLoginPJeAberta = false;
    }

    abrirLoginPJe = () => {
        window.open(this.montarUrlLoginPJeTst());
    }

    abrirDetalheProcessoPJe = () => {
        window.open(this.montarUrlDetalheProcessoPJe());
    }

    mandala = async () => {
        // let urlRedirect = Ambiente.urlPJe + this.props.idProcesso + '/detalhe';
        // encontrar perfil do mesmo oj e ojc
        // if (usuario && usuario.localizacoes?.length > 0) {
        //     usuario.localizacoes.forEach((perfil) => {
        //         if (!tarefa.deveriaEstarNoGabineteEletronico && ojcDescricao == perfil.orgaoJulgadorColegiado && perfil.orgaoJulgador == undefined) {
        //             // procura apenas por ojc
        //             idPerfil = perfil.idPapel;
        //         } else if (tarefa.deveriaEstarNoGabineteEletronico && ojcDescricao == perfil.orgaoJulgadorColegiado && ojDescricao == perfil.orgaoJulgador) {
        //             idPerfil = perfil.idPapel;
        //         }
        //     })
        // }

        // if (idPerfil == 0) {
        //     if (tarefa.deveriaEstarNoGabineteEletronico)
        //         MensagemStore.apresentarAviso('Usuario sem localizacao para o orgão julgador: ' + ojDescricao + ' no Orgão Julgador Colegiado: ' + ojcDescricao);
        //     else
        //         MensagemStore.apresentarAviso('Tarefa não visivel para o usuario no orgão julgador: ' + ojDescricao + ' no Orgão Julgador Colegiado: ' + ojcDescricao);
        //     return;
        // }

        // let refreshToken = tokenLogus.tokens.kz_refresh.token;
        // let redirectPageWithSSO = Ambiente.urlPJe.split("pjekz")[0] + "btv/bemtevi/tst-sso.html?id_perfil=" + idPerfil + "&redirect_url=" + urlRedirect + "&refresh_token=" + refreshToken;
        // window.open(redirectPageWithSSO);

        if (!this.orientacaoLoginPJeJaExibida() && this.clicouNoMesmoProcessoRecentemente()) {
            this.abrirModalOrientacaoLoginPJe();
            return;
        }

        this.registrarCliqueProcesso();

        window.open(this.montarUrlDetalheProcessoPJe());
    }

    renderModalOrientacaoLoginPJe() {
        return (
            <Dialog open={this.modalOrientacaoLoginPJeAberta} onClose={this.fecharModalOrientacaoLoginPJe}>
                <DialogTitle>Acesso ao PJe</DialogTitle>
                <DialogContent>
                    Para abrir o detalhe do processo no PJe, é necessário estar autenticado no PJe.
                    Caso a sessão ainda não esteja ativa, acesse o login do PJe e depois abra novamente o detalhe do processo.
                </DialogContent>
                <DialogActions>
                    <Button variant='text' color='secondary' sx={{ borderRadius: 10 }} onClick={this.fecharModalOrientacaoLoginPJe}>
                        Fechar
                    </Button>
                    <Button variant='outlined' color='primary' sx={{ borderRadius: 10 }} onClick={this.abrirDetalheProcessoPJe}>
                        Abrir detalhe
                    </Button>
                    <Button variant='contained' color='primary' sx={{ borderRadius: 10 }} onClick={this.abrirLoginPJe}>
                        Acessar login
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }

    render() {
        return (
            <div style={{ cursor: 'pointer' }}>
                {
                    <Tooltip title='Abrir processo no PJe'>
                        <IconButton
                            size={this.props.tamanhoBotao}
                            onClick={this.mandala}
                            aria-label='Abrir processo no PJe. Irá abrir em uma nova página.'
                            sx={this.props.larguraIcone || this.props.alturaIcone ? {
                                padding: 0,
                                width: this.props.larguraIcone,
                                height: this.props.alturaIcone,
                                minWidth: this.props.larguraIcone,
                                minHeight: this.props.alturaIcone,
                                '&.MuiIconButton-root': {
                                    width: this.props.larguraIcone,
                                    height: this.props.alturaIcone,
                                    padding: 0
                                }
                            } : undefined}
                        >
                            <IconePje width={this.props.larguraIcone} height={this.props.alturaIcone} />
                        </IconButton>
                    </Tooltip>
                }
                {this.renderModalOrientacaoLoginPJe()}
            </div>
        );
    }
}

export default observer(BotaoAbrirProcessoPJe);
